export const RolesTooltip = () => (
  <>
    The owner can add a list of AWS IAM role ARNs which will have corresponding
    level of access to the files in the pond.
  </>
);
